module.exports = __webpack_public_path__ + "img/shohoz.5ea50dfe.png";